import { Component, Input, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.component.html',
  styleUrls: ['./country-list.component.scss']
})
export class CountryListComponent implements OnInit {
@Input('data') data: any;
  countries: any;
  backupCountries: any;
constructor() {  

}

  ngOnInit() {
    this.countries = this.data;
    this.backupCountries = JSON.parse(JSON.stringify(this.data));

  }

  async filterList(evt) {
    this.countries = this.backupCountries;
    const searchTerm = evt.srcElement.value;
  
    if (!searchTerm) {
      return;
    }
  
    this.countries = this.countries.filter(currentFood => {
      if (currentFood.countryName && searchTerm) {
        return (currentFood.countryName.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1)
      }
    });
  }

}
